import { useQuery } from "react-query"
import { AxiosResponse } from "axios"
import reportService from "api/reportService"

const useGetReportSources = (enabled: boolean) => {
  return useQuery(
    "report-sources",
    async () => {
      const res: AxiosResponse<any> = await reportService.getReportSources()

      return res.data
    },
    { enabled },
  )
}

export default useGetReportSources
